import { Swiper, Scrollbar } from "swiper/bundle";
export default class SwiperTimeline {
    constructor() {
        console.log('%c👍🏼 Swiper Timeline', 'color: yellow');
        
        this.swiperTimeline = document.querySelectorAll(
            '.swiper--timeline'
        )
    }
    init() {
        this.swiperTimeline.forEach((elem, i) => {
            new Swiper(elem, {
                slidesPerView: 1,
                loop: false,
                spaceBetween: 20,
                speed: 1001,
                slideToClickedSlide: false,
                allowTouchMove: false,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: '50px'
                  },

                breakpoints: {
                    568: {
                        spaceBetween: 100,
                    scrollbar: {
                        dragSize: '133px'
                      },
                    }
                }
            });   
        })
    }
}